import GoTrue from 'gotrue-js'

const auth = new GoTrue({
    APIUrl: `https://${process.env.VUE_APP_IDENTITY_URL}/.netlify/identity`, // process.env.VUE_APP_IDENTITY_URL,
    audience: '',
    setCookie: false,
  })

export default auth
